<template>
  <div>
    <div class="hr"></div>
    <div v-for="index in resolution" :key="index" class="resolution">
      <h4>Resolution {{ index }}</h4>
      Sample Resolution {{ index }}
      <div class="selection-block">
        <div class="selection" @click="selectResolution($event, index)">For</div>
        <div class="selection" @click="selectResolution($event, index)">Against</div>
        <div class="selection" @click="selectResolution($event, index)">Abstain</div>
      </div>
      <div class="hr"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormPFRT",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      resolution: [1, 2],
    };
  },
  methods: {
    selectResolution: function (event, index) {
      const target = event.target;
      const selections = this.$el.querySelectorAll(".selection-block")[index-1];
      if (target.classList.contains("blocked")) {
        return;
      } else if (target.classList.contains("selected")) {
        Array.from(selections.childNodes).forEach(selection => {
          selection.classList.remove("blocked");
        })
        target.classList.remove("selected");
      } else {
        Array.from(selections.childNodes).forEach(selection => {
          selection.classList.add("blocked");
        })
        target.classList.remove("blocked");
        target.classList.add("selected");
      }
    }
  },
};
</script>

<style scoped>
.resolution {
  padding: 0.75rem 0;
}

.resolution h4 {
  margin: 0;
}

.hr {
  background: #d7d7d7;
  height: 1px;
}

.selection-block {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 0.75rem 0 1.5rem -8px;
}

.selection {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  min-height: 40px;
  width: 160px;
  cursor: pointer;
  color: #0073C3;
  border: 1px solid #0073C3;
  border-radius: 0.25rem;
  margin: 8px 0 0 8px;
  transition-property: opacity, background-color;
  transition-duration: 0.12s;
  transition-timing-function: ease-in;
}

.selection:hover {
  background: #0073C326;
}

.selected {
  background: #0073C3;
  color: #fff;
}

.selected:hover {
  background: #0073C3;
}

.blocked {
  cursor: not-allowed;
  opacity: 0.4;
}

.required {
  color: #f00;
}
</style>